<template>
  <AutoSuggest
    v-if="games.length"
    v-model="valueModel"
    class="mb-4 games-autocomplete"
    :label="$$t('Games', 'games_label')"
    multiple
    only-unique
    :source="games"
    name="gamesSelection"
    :placeholder="$$t('Add Games...', 'games-filter-placeholder')"
    display-property="name"
    :show-on-focus="true"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { prop } from '@/utils/factories';
import { translate } from '@/mixins/translate';
import AutoSuggest from '@/components/molecules/form/autoComplete/HeraAutosuggest.vue';

export default {
  components: {
    AutoSuggest,
  },
  mixins: [translate('_web_filters')],

  props: {
    value: prop(null),
    label: prop(String),
  },

  computed: {
    // TODO: Use mapState
    ...mapGetters(['games']),
    valueModel: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue.map(game => game.id));
      },
    },
  },

  created() {
    this.fetchGames();
  },

  methods: {
    ...mapActions(['fetchGames']),
  },
};
</script>
